import { z } from 'zod';
import { v4 as uuidv4 } from 'uuid';
import { AdditionalFilters } from './policy-filters';
import yaml from 'yaml';
import { InputError } from '@mainstage/errors';

const OBJECT_ERROR_MSG = 'The descriptor must be a non-empty valid YAML.';

const getDescriptor = z.object({
  resource: z.object({
    descriptor: z.string(),
    resourceType: z.string(),
    environment: z.string(),
  }),
});

export interface ResourceInput {
  resource?: {
    descriptor: string;
    resourceType: string;
    environment: string;
  };
}

export interface PolicyTestRequestBodyInput
  extends AdditionalFilters,
    ResourceInput {}

export const descriptorParser = z.object(
  {},
  { required_error: OBJECT_ERROR_MSG, invalid_type_error: OBJECT_ERROR_MSG },
);

export interface AdditionalResource {
  resource?: {
    id: string;
    environment: string;
    resourceType: string;
    descriptor: string;
  };
}

function throwIfNotValidDescriptor(descriptor: string) {
  if (!descriptor || descriptor.trim() === '') {
    throw new InputError(OBJECT_ERROR_MSG);
  }

  try {
    return yaml.parse(descriptor);
  } catch (e) {
    throw new InputError(OBJECT_ERROR_MSG);
  }
}
export interface PolicyTestRequestBody
  extends AdditionalFilters,
    AdditionalResource {}

export function resourceToPolicyTestRequestBody(
  resource: ResourceInput,
): AdditionalResource {
  const validatedResource = getDescriptor.parse(resource);
  const descriptor = validatedResource.resource.descriptor;
  throwIfNotValidDescriptor(descriptor);

  return {
    resource: {
      // Generating a random id for the resource since it's required but not provided by the user.
      // If resource type configures a specific id field, it will be extracted during policy evaluation. Otherwise, this random ID will be used.
      id: `test-resource-${uuidv4()}`,
      environment: validatedResource.resource.environment,
      resourceType: validatedResource.resource.resourceType,
      descriptor: descriptor,
    },
  };
}
